import { dpiToScale, PAGE_SIZES } from '../../lib/print-layout';

export const PREVIEW_WRAPPER_ATTR = 'data-print-preview';

/**
 * Render the composed page node to a canvas at the chosen dpi (the node is laid out at 96 dpi,
 * so scale = dpi/96). The preview shrinks the page with a CSS transform on an ancestor; the
 * clone html2canvas renders has it removed so the capture is at full size.
 */
export async function renderPageCanvas(node, dpi = 150) {
  const { default: html2canvas } = await import('html2canvas');
  return html2canvas(node, {
    scale: dpiToScale(dpi),
    backgroundColor: '#ffffff',
    useCORS: true,
    logging: false,
    onclone: (doc) => {
      doc.querySelectorAll(`[${PREVIEW_WRAPPER_ATTR}]`).forEach((el) => { el.style.transform = 'none'; });
    },
  });
}

export const safeName = (s) => String(s || 'map').replace(/[^\w-]+/g, '_').replace(/^_+|_+$/g, '') || 'map';

export async function exportPng(node, { dpi, title }) {
  const canvas = await renderPageCanvas(node, dpi);
  const link = document.createElement('a');
  link.download = `${safeName(title)}_map_${dpi}dpi.png`;
  link.href = canvas.toDataURL('image/png');
  link.click();
  return canvas;
}

/** PDF with the exact paper size (mm) of the chosen format and orientation. */
export async function exportPdf(node, { dpi, title, size, orientation }) {
  const [canvas, { jsPDF }] = await Promise.all([renderPageCanvas(node, dpi), import('jspdf')]);
  const pdf = new jsPDF({ orientation, unit: 'mm', format: PAGE_SIZES[size] ? size : 'a4' });
  pdf.addImage(canvas.toDataURL('image/jpeg', 0.95), 'JPEG', 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight(), undefined, 'FAST');
  pdf.save(`${safeName(title)}_map_${dpi}dpi.pdf`);
  return canvas;
}

/** PNG data URL of the composed page, for the Report Builder hand-off. */
export async function pageDataUrl(node, dpi = 150) {
  const canvas = await renderPageCanvas(node, dpi);
  return canvas.toDataURL('image/png');
}
